module.exports = __webpack_public_path__ + "img/medifox.e0aa9ec9.png";